import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc4c96f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_2 = { class: "footer-box" }
const _hoisted_3 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}

import { ref, onUnmounted, reactive } from 'vue';
  import { request, Validator } from '@/utils';
  import { useToast } from 'bootstrap-vue-3';
  import { useI18n } from 'vue-i18n';
  import { FormItem } from '@/types/form';

  interface IProps {
    target: string;
    // 插入类型，all：target和图片验证码全表单开放 half: 只开放图片验证码，none: 表示不用弹窗表单
    insert: 'all' | 'half' | 'none';
    targetType: 'phone_number' | 'email';
    event: 'sign_up' | 'reset_password' | 'verify_email' | 'verify_phone_number';
    captcha?: string;
    showCountDown?: boolean;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    target: null,
    insert: { default: 'none' },
    targetType: { default: 'phone_number' },
    event: { default: 'sign_up' },
    captcha: null,
    showCountDown: { type: Boolean, default: true }
  },
  emits: ['reset'],
  setup(__props: any, { emit: emits }) {

const props = __props as { target: string, insert: 'all' | 'half' | 'none', targetType: 'phone_number' | 'email', event: 'sign_up' | 'reset_password' | 'verify_email' | 'verify_phone_number', captcha?: string, showCountDown: boolean }

  const { t } = useI18n();
  const toast = useToast();
  const loading = ref(false);
  
  

  const showModal = ref(false);
  const form = reactive({
    target: '',
    captcha: ''
  });
  const list = getList();
  const timeout = ref<any>(null);
  const count = ref(60);
  const tipsText = props.targetType === 'phone_number' ? t('Phone is required') : t('Email address is required');
  const captchaTipsText = t('Captcha is required');

  function getList() {
    const list: FormItem[] = [
      {
        label: t('CAPTCHA'),
        type: 'custom',
        required: true,
        placeholder: t('Captcha'),
        key: 'captcha',
        inputType: 'text',
      }
    ];
    if (props.insert === 'all') {
      list.unshift({
        label: props.targetType === 'phone_number' ? t('PHONE') : t('EMAIL ADDRESS'),
        type: 'input',
        required: true,
        placeholder: props.targetType === 'phone_number' ? 'phone' : 'email',
        key: 'target',
        inputType: props.targetType === 'email' ? 'email' : 'text',
      });
    }
    return list;
  }

  function formItemChange(data: any) {
    form[data.key] = data.value;
  }

  function handleSend() {
    if (timeout.value) {
      return;
    }
    // half none 需要校验target的值
    if (props.insert !== 'all') {
      if (!props.target) {
        toast.show({ title: t('Tips'), body: tipsText }, { variant: 'warning' });
        return;
      }
      if (props.targetType === 'phone_number') {
        const isValid = Validator.isPhoneNumberValid(props.target);
        if (!isValid) {
          toast.show({ title: t('Tips'), body: t('phoneNumberIsInValid') }, { variant: 'warning' });
          return;
        }
      }
    }
    // 全依赖外部的情况校验target captcha
    if (props.insert === 'none' && (!props.target || !props.captcha)) {
      toast.show({ title: t('Tips'), body: props.target ? captchaTipsText : tipsText }, { variant: 'warning' });
      return;
    }
    if (props.insert === 'none') {
      handleSubmit();
    } else {
      showModal.value = true;
    }
  }

  async function handleSubmit() {
    if (loading.value) {
      return;
    }
    const params = {
      target: props.insert !== 'all' ? props.target : form.target,
      event: props.event,
      g_recaptcha_response: props.insert === 'none' ? props.captcha : form.captcha,
      target_type: props.targetType
    };

    loading.value = true;
    try {
      const { data } = await request.post('/verification_codes', params);
      loading.value = false;
      showModal.value = false;
      toast.show({ title: t('Tips'), body: data.message }, { variant: 'success' });
      count.value = 60;
      countdown();
      form.captcha = '';
    } catch (error) {
      loading.value = false;
      emits('reset');
      form.captcha = '';
    }
  }

  function countdown() {
    if (count.value <= 0) {
      clearTimeout(timeout);
      timeout.value = null;
      return;
    }
    timeout.value = setTimeout(() => {
      count.value -= 1;
      countdown();
    }, 1000);
  }

  onUnmounted(() => {
    if (timeout.value) {
      clearTimeout(timeout);
      timeout.value = null;
    }
  });

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_GoogleRecaptcha = _resolveComponent("GoogleRecaptcha")!
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_b_button, {
      class: "code-btn",
      disabled: loading.value || Boolean(timeout.value),
      onClick: handleSend
    }, {
      default: _withCtx(() => [
        (loading.value && __props.insert === 'none')
          ? (_openBlock(), _createElementBlock("span", _hoisted_1))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(timeout.value ? (__props.showCountDown ? count.value + 's' : _unref(t)('sended')) : _unref(t)('Send verification code')), 1)
      ]),
      _: 1
    }, 8, ["disabled"]),
    (__props.insert !== 'none')
      ? (_openBlock(), _createBlock(_component_AppDialog, {
          key: 0,
          visible: showModal.value,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((showModal).value = $event)),
          title: _unref(t)('Verification code'),
          btns: []
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form, {
              class: "dialog-form",
              onSubmit: handleSubmit
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item) => {
                  return (_openBlock(), _createBlock(_component_AppFormGroupItem, {
                    key: item.key,
                    config: item,
                    form: _unref(form),
                    onChange: formItemChange
                  }, _createSlots({ _: 2 }, [
                    (item.key === 'captcha')
                      ? {
                          name: "custom",
                          fn: _withCtx(() => [
                            _createVNode(_component_GoogleRecaptcha, {
                              modelValue: _unref(form)['captcha'],
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form)['captcha']) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        }
                      : undefined
                  ]), 1032, ["config", "form"]))
                }), 128)),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_b_button, {
                    pill: "",
                    variant: "outline-primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showModal.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('Close')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_button, {
                    pill: "",
                    variant: "primary",
                    type: "submit",
                    disabled: loading.value
                  }, {
                    default: _withCtx(() => [
                      (loading.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_unref(t)('Send')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["visible", "title"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})